import { render, staticRenderFns } from "./agencyStatementList.vue?vue&type=template&id=39993683&scoped=true"
import script from "./agencyStatementList.vue?vue&type=script&lang=js"
export * from "./agencyStatementList.vue?vue&type=script&lang=js"
import style0 from "./agencyStatementList.vue?vue&type=style&index=0&id=39993683&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39993683",
  null
  
)

export default component.exports